import { render, staticRenderFns } from "./BannerCarousel.vue?vue&type=template&id=05337c1e&scoped=true&"
import script from "./BannerCarousel.vue?vue&type=script&lang=js&"
export * from "./BannerCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05337c1e",
  null
  
)

export default component.exports